import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { ArrowLeft, CalendarDays, FileImage, Globe2, Heart, Settings, Shirt, Users } from "lucide-react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSnapshot } from "valtio";

import { editorState } from "../../../utils/editor";
import { useEventPlannerPath } from "../../../hooks/useEventPlannerPath";
import { getCoupleDisplayName } from "../../../utils/couple.names";

const PlannerWeddingShell = () => {
  const { basePath } = useEventPlannerPath();
  const { pathname } = useLocation();
  const wedding = useSnapshot(editorState);
  const currentPath = pathname.replace(/\/+$/, "");
  // The designs tab opens the workspace designs route, which resolves to the
  // wedding design configuration while the design studio rollout is disabled.
  const onDesigns =
    currentPath.startsWith(`${basePath}/design`) ||
    currentPath.startsWith(`${basePath}/website/design`);
  const onWebsite =
    currentPath.startsWith(`${basePath}/website`) && !onDesigns;
  const links = [
    { to: basePath, label: "Overview", icon: CalendarDays, current: currentPath === basePath },
    { to: `${basePath}/guests`, label: "Guests", icon: Users, current: currentPath.startsWith(`${basePath}/guests`) },
    { to: `${basePath}/design`, label: "Designs", icon: FileImage, current: onDesigns },
    { to: `${basePath}/love-wall`, label: "Love Wall", icon: Heart, current: currentPath.startsWith(`${basePath}/love-wall`) },
    { to: `${basePath}/aso-ebi`, label: "Aso Ebi", icon: Shirt, current: currentPath.startsWith(`${basePath}/aso-ebi`) },
    { to: `${basePath}/website`, label: "Website", icon: Globe2, current: onWebsite },
    { to: `${basePath}/settings/collaboration`, label: "Access", icon: Settings, current: currentPath.startsWith(`${basePath}/settings`) },
  ];
  const couple = getCoupleDisplayName(wedding) || "Client wedding";

  return (
    <Box w="full">
      <Box px={{ base: 4, md: 8 }} pb={4}>
        <Flex maxW="1380px" mx="auto" justify="space-between" align={{ base: "flex-start", md: "center" }} gap={4} flexDir={{ base: "column", md: "row" }}>
          <Box minW={0}><Button as={Link} to="/planner/weddings" variant="link" leftIcon={<ArrowLeft size={16} />} color="#555B58" fontSize="13px">All weddings</Button><Text mt={2} fontSize="24px" fontWeight={600} wordBreak="break-word">{couple}</Text><Text fontSize="13px" color="#737773">Client wedding workspace</Text></Box>
          <Flex gap={1} overflowX="auto" maxW="full" pb={1}>{links.map(({ to, label, icon: Icon, current }) => <Link key={to} to={to}><Flex px={3} py={2} gap={2} align="center" whiteSpace="nowrap" borderRadius="9px" bg={current ? "black" : "white"} color={current ? "white" : "#343834"} border="1px solid #E2E2DD"><Icon size={15} /><Text fontSize="12px" fontWeight={600}>{label}</Text></Flex></Link>)}</Flex>
        </Flex>
      </Box>
      <Outlet />
    </Box>
  );
};

export default PlannerWeddingShell;
